import React, {PureComponent} from "react";
import {withTranslation} from "react-i18next";
import {i18nizeDate, numberWithCommas} from "../helpers/Utils";
import UserInfo from "../components/UserInfo";
import {Table} from "reactstrap";

class BonusCardDetails extends PureComponent {
  getBonusValue = params => {
    const {t, bonusCard} = this.props;
    const {effectObject} = bonusCard;
    const {percent, limit, amount, pairs, extendToCurrent} = params;
    if (effectObject === "TRADE_FEE") {
      return t(
        typeof amount !== "undefined" ? "{{value}} as new trade fee amount in {{target}}" : "{{value}} percent discount on trade fee amount in {{target}}",
        {
          value: typeof amount !== "undefined" ? numberWithCommas(amount) : percent,
          target: pairs && pairs.length ? pairs.join(", ") : t("all markets"),
        }
      )
    }
    return t("{{value}} percent as new referral fee receive by user", {
      value: limit,
    }) + (extendToCurrent ? ` (${t("Extend To Current")})` : "");
  };

  getExpireCriteria = items => {
    const {t} = this.props;
    return (
      <div>
        {items.map(item => {
          const {name, params} = item;
          if (name === "EndTime") {
            return (
              <div key={name} className="my-1">
                {t("until {{time}} date", {time: i18nizeDate(params.time)})}
              </div>
            );
          }
          if (name === "UsageTime") {
            return (
              <div key={name} className="my-1">
                {t("{{interval}} days after activation", {interval: numberWithCommas(params.interval)})}
              </div>
            );
          }
          if (name === "TotalVol") {
            return (
              <div key={name} className="my-1">
                {t("until {{amount}} TMN trade volume", {amount: numberWithCommas(Number(params.vol))})}
              </div>
            );
          }
        })}
      </div>
    );
  };

  render() {
    const {t, bonusCard} = this.props;
    const {effectFunction, endValidityCriteria, expireFunctions, creator} = bonusCard;
    return (
      <div className="table-row-sub py-2">
        <Table bordered responsive>
          <tbody>
          <tr>
            <td style={{width: 150}} className="text-info">{t('Bonus Value')}</td>
            <td className="py-1">{this.getBonusValue(effectFunction.params)}</td>
          </tr>
          {!!endValidityCriteria && (!!endValidityCriteria.time || !!endValidityCriteria.numUsage) &&
            <tr>
              <td style={{width: 150}} className="text-info">{t('Validity Conditions')}</td>
              <td>
                <div>
                  {!!endValidityCriteria.time && <div className="my-1">{t("until {{time}} date", {time: i18nizeDate(endValidityCriteria.time)})}</div>}
                  {!!endValidityCriteria.numUsage && <div className="my-1">{t("until {{num}} usage", {num: numberWithCommas(endValidityCriteria.numUsage)})}</div>}
                </div>
              </td>
            </tr>
          }
          {!!expireFunctions && expireFunctions.length > 0 &&
            <tr>
              <td style={{width: 150}} className="text-info">{t('Expiration conditions')}</td>
              <td>{this.getExpireCriteria(expireFunctions)}</td>
            </tr>
          }
          <tr>
            <td style={{width: 150}} className="text-info">{t('Creator')}</td>
            <td>
              <UserInfo
                textColor="text-dark"
                label={t('Admin')}
                id={creator.value}
                type="ADMIN"
              />
            </td>
          </tr>
          </tbody>
        </Table>
      </div>
    );
  }
}

export default withTranslation()(BonusCardDetails);